import { eventData, Ga4WrapperService } from '@am/ga4-wrapper';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { IHotelsAppState } from '@store/index';
import { selectSearchBoxParams } from '@store/router/router.selector';
import { filter, map, take } from 'rxjs/operators';
import { ErrorParams } from '../models/ga4/interfaces/ErrorParams';
import { EventItemParamsClass } from './../models/ga4/event_item_params.class';
import { DateService } from './date.service';
import { SearchService } from './search.service';

@Injectable({
  providedIn: 'root',
})
export class Ga4Service {
  private newDataItemParams: EventItemParamsClass;
  private disney_city = '2359298';
  private universal_city = 'new6280590';
  private productoValue = '';
  constructor(
    private store$: Store<IHotelsAppState>,
    private searchService: SearchService,
    private dateService: DateService,
    private ga4WrapperService: Ga4WrapperService,
  ) {
    this.newDataItemParams = new EventItemParamsClass(
      this.store$,
      this.searchService,
      this.dateService,
    );
    this.getProducto();
  }

  // ComunEvents
  private createEventData(eventName: string): eventData {
    return {
      event: 'ga4.trackEvent',
      eventName,
      eventParams: {},
    };
  }

  private eventItemParams(isPLP = true): any {
    return isPLP
      ? { ...this.newDataItemParams.getData() }
      : { ...this.newDataItemParams.getDataResume() };
  }

  // TagEvent GA4;
  public view_item_list() {
    const objectEvent: eventData = this.createEventData('view_item_list');
    objectEvent.eventParams = this.eventItemParams();
    this.store$
      .pipe(
        select(selectSearchBoxParams),
        filter((data: any) => data !== undefined),
        map((data) => this.searchService.prepareSearchInfo(data)),
        take(1),
      )
      .subscribe((response) => {
        objectEvent.eventParams.item_list_id = response.origin.id;
        const text_item =
          response.origin.id === this.disney_city
            ? 'disney'
            : response.origin.id === this.universal_city
            ? 'universal'
            : 'alojamiento';
        objectEvent.eventParams.item_list_name = `${text_item} :: ${response.origin.label}`;
        objectEvent.eventParams.items = this.newDataItemParams.createItems();
        objectEvent.eventParams.currency = (response.currencyCode as string)?.toLowerCase();
        this.ga4WrapperService.callEvent(objectEvent);
      });
  }

  public select_item<T>(hotel_selected, section = 'plp') {
    const objectEvent: eventData = this.createEventData('select_item');
    objectEvent.eventParams = this.eventItemParams(section === 'plp') as T;

    this.store$
      .pipe(
        select(selectSearchBoxParams),
        filter((data: any) => data !== undefined),
        map((data) => this.searchService.prepareSearchInfo(data)),
        take(1),
      )
      .subscribe((response) => {
        const text_item =
          response.origin.id === this.disney_city
            ? 'disney'
            : response.origin.id === this.universal_city
            ? 'universal'
            : 'alojamiento';

        if (section === 'plp') {
          objectEvent.eventParams.item_list_name = `${text_item} :: ${response.origin.label}`;
          objectEvent.eventParams.items = this.newDataItemParams.createItems(hotel_selected);
        } else {
          objectEvent.eventParams.item_list_name = `${text_item} :: ${response.origin.label}`;
        }

        if (objectEvent.eventParams.producto === 'alojamiento') {
          objectEvent.eventParams.recomendado = hotel_selected.recommended ? 'si' : 'no';
        }
        objectEvent.eventParams.servicios = this.loadAlojamiento(hotel_selected);
        this.ga4WrapperService.callEvent(objectEvent);
      });
  }

  public loadAlojamiento(hotel: any) {
    let strServicios = '';
    if (hotel.amenities !== undefined) {
      hotel.amenities.forEach((amenitie) => {
        strServicios += amenitie.description + ' // ';
      });
    }
    return strServicios;
  }

  public error(error: any) {
    const objectEvent: eventData = this.createEventData('error');
    objectEvent.eventParams = this.eventItemParams() as ErrorParams;

    objectEvent.eventParams.error_type = '-';
    objectEvent.eventParams.error_message = error.message;
    objectEvent.eventParams.error_place = 'Disponibilidad de hoteles';
    objectEvent.eventParams.error_code = error.code;
    objectEvent.eventParams.error_format = '-';
    objectEvent.eventParams.request_id = '-';
    objectEvent.eventParams.producto = this.productoValue;
    return this.ga4WrapperService.callEvent(objectEvent);
  }

  public user_interaction(data: any, globalSection?: any) {
    const objectEvent: eventData = this.createEventData('user_interaction');
    objectEvent.eventParams.element = `${data.type} :: ${data.label}`.toLocaleLowerCase();
    objectEvent.eventParams.action = data.action;
    objectEvent.eventParams.section = `${
      globalSection !== undefined ? globalSection + ' :: ' : ''
    }${data.section}`.toLowerCase();
    objectEvent.eventParams.producto = this.productoValue;
    this.ga4WrapperService.callEvent(objectEvent);
  }

  public search(data: any, globalSection: string) {
    const objectEvent: eventData = this.createEventData('search');

    const dataTracking = {
      producto: this.productoValue,
      search_term: data.search_term,
      section: `${globalSection} :: ${data.section}`.toLowerCase(),
    };
    objectEvent.eventParams = { ...dataTracking };
    this.ga4WrapperService.callEvent(objectEvent);
  }

  private getProducto() {
    this.store$
      .pipe(
        select(selectSearchBoxParams),
        filter((data: any) => data !== undefined),
        map((data) => this.searchService.prepareSearchInfo(data)),
        take(1),
      )
      .toPromise()
      .then((response) => {
        this.productoValue =
          response.origin.id === this.disney_city
            ? 'disney'
            : response.origin.id === this.universal_city
            ? 'universal'
            : 'alojamiento';
      })
      .catch(() => {
        this.productoValue = '';
      });
  }
}
